export const banners = [
  {
    id: '1',
    title: 'عروض خاصة على الأجهزة المنزلية',
    subtitle: 'خصومات تصل إلى 40% على مجموعة مختارة',
    image: 'https://public.readdy.ai/ai/img_res/4e0a85d240ea61e1775b6421d74de940.jpg',
    buttonText: 'تسوق الآن',
    link: '/categories',
  },
  {
    id: '2',
    title: 'حلول متكاملة لتجهيز السوبرماركت',
    subtitle: 'ثلاجات عرض، أرفف، وكل ما تحتاجه لمشروعك',
    image: 'https://readdy.ai/api/search-image?query=modern%20supermarket%20equipment%20display%20refrigerators%20shelving%20systems%20shopping%20carts%20in%20professional%20retail%20store%20clean%20organized%20commercial%20space%20bright%20lighting%20simple%20background&width=1920&height=500&seq=banner2&orientation=landscape',
    buttonText: 'اطلب عرض سعر',
    link: '/quote-request',
  },
  {
    id: '3',
    title: 'مشاريع التبريد والتكييف',
    subtitle: 'غرف تبريد ومستودعات بأحدث التقنيات',
    image: 'https://readdy.ai/api/search-image?query=industrial%20cooling%20system%20cold%20storage%20warehouse%20refrigeration%20units%20modern%20commercial%20facility%20professional%20installation%20clean%20industrial%20environment%20simple%20background&width=1920&height=500&seq=banner3&orientation=landscape',
    buttonText: 'استكشف الحلول',
    link: '/categories',
  },
];

export const categories = [
  {
    id: 'home-appliances',
    name: 'الأجهزة المنزلية',
    icon: 'ri-home-4-line',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20modern%20home%20appliances%20refrigerator%20washing%20machine%20air%20conditioner%20in%20elegant%20showroom%20professional%20product%20display%20clean%20white%20background%20luxury%20retail%20environment&width=800&height=600&seq=cat1&orientation=portrait',
    subcategories: ['ثلاجات منزلية', 'شاشات LED', 'مكيفات سبليت', 'غسالات', 'مجففات', 'أفران'],
  },
  {
    id: 'supermarket-equipment',
    name: 'تجهيزات السوبرماركت',
    icon: 'ri-store-2-line',
    image: 'https://readdy.ai/api/search-image?query=supermarket%20commercial%20equipment%20display%20refrigerators%20shelving%20units%20checkout%20counters%20in%20modern%20retail%20store%20professional%20commercial%20setup%20clean%20organized%20simple%20background&width=800&height=600&seq=cat2&orientation=portrait',
    subcategories: ['ثلاجات عرض', 'غرف تبريد', 'عربات التسوق', 'أرفف', 'كاونترات', 'أنظمة الكاشير'],
  },
  {
    id: 'project-solutions',
    name: 'حلول المشاريع الكبرى',
    icon: 'ri-building-line',
    image: 'https://readdy.ai/api/search-image?query=large%20scale%20industrial%20warehouse%20project%20cold%20storage%20facility%20commercial%20refrigeration%20systems%20modern%20logistics%20center%20professional%20installation%20clean%20industrial%20space&width=800&height=600&seq=cat3&orientation=portrait',
    subcategories: ['مشاريع المستودعات', 'مشاريع السوبرماركت', 'مشاريع التبريد', 'مشاريع التكييف'],
  },
];

export const featuredProducts = [
  {
    id: 'prod-1',
    name: 'ثلاجة سامسونج 21 قدم',
    brand: 'سامسونج',
    price: 3499,
    oldPrice: 4299,
    discount: 19,
    rating: 4.8,
    reviews: 156,
    image: 'https://readdy.ai/api/search-image?query=samsung%20french%20door%20refrigerator%2021%20cubic%20feet%20stainless%20steel%20modern%20design%20product%20photography%20on%20clean%20white%20background%20professional%20studio%20lighting&width=600&height=600&seq=prod1&orientation=squarish',
    badge: 'الأكثر مبيعاً',
    inStock: true,
    categoryId: 'home-appliances',
  },
  {
    id: 'prod-2',
    name: 'مكيف إل جي 24 وحدة',
    brand: 'إل جي',
    price: 2799,
    rating: 4.6,
    reviews: 89,
    image: 'https://readdy.ai/api/search-image?query=lg%20split%20air%20conditioner%2024000%20btu%20white%20modern%20unit%20product%20photography%20clean%20white%20background%20professional%20studio%20shot&width=600&height=600&seq=prod2&orientation=squarish',
    inStock: true,
    categoryId: 'home-appliances',
  },
  {
    id: 'prod-3',
    name: 'ثلاجة عرض تجارية 3 أبواب',
    brand: 'بوش',
    price: 8999,
    rating: 4.9,
    reviews: 45,
    image: 'https://readdy.ai/api/search-image?query=commercial%20display%20refrigerator%20three%20glass%20doors%20stainless%20steel%20supermarket%20equipment%20product%20photography%20clean%20white%20background%20professional%20lighting&width=600&height=600&seq=prod3&orientation=squarish',
    badge: 'جديد',
    inStock: true,
    categoryId: 'supermarket-equipment',
  },
  {
    id: 'prod-4',
    name: 'غسالة وايت ويل 10 كيلو',
    brand: 'وايت ويل',
    price: 1899,
    oldPrice: 2299,
    discount: 17,
    rating: 4.5,
    reviews: 203,
    image: 'https://readdy.ai/api/search-image?query=white%20whale%20front%20load%20washing%20machine%2010kg%20white%20modern%20design%20product%20photography%20clean%20white%20background%20studio%20lighting&width=600&height=600&seq=prod4&orientation=squarish',
    inStock: true,
    categoryId: 'home-appliances',
  },
];

export const bestSellers = [
  {
    id: 'prod-5',
    name: 'شاشة توشيبا 55 بوصة 4K',
    brand: 'توشيبا',
    price: 2199,
    rating: 4.7,
    reviews: 178,
    image: 'https://readdy.ai/api/search-image?query=toshiba%2055%20inch%204k%20smart%20tv%20ultra%20hd%20led%20television%20modern%20slim%20design%20product%20photography%20clean%20white%20background%20professional%20studio&width=600&height=600&seq=prod5&orientation=squarish',
    inStock: true,
    categoryId: 'home-appliances',
  },
  {
    id: 'prod-6',
    name: 'عربة تسوق سوبرماركت 180 لتر',
    brand: 'كريازي',
    price: 450,
    rating: 4.4,
    reviews: 67,
    image: 'https://readdy.ai/api/search-image?query=supermarket%20shopping%20cart%20180%20liter%20metal%20chrome%20finish%20retail%20equipment%20product%20photography%20clean%20white%20background%20professional%20shot&width=600&height=600&seq=prod6&orientation=squarish',
    inStock: true,
    categoryId: 'supermarket-equipment',
  },
  {
    id: 'prod-7',
    name: 'فرن كهربائي شارب 60 سم',
    brand: 'شارب',
    price: 1599,
    oldPrice: 1899,
    discount: 16,
    rating: 4.6,
    reviews: 92,
    image: 'https://readdy.ai/api/search-image?query=sharp%20electric%20oven%2060cm%20stainless%20steel%20built%20in%20kitchen%20appliance%20product%20photography%20clean%20white%20background%20professional%20lighting&width=600&height=600&seq=prod7&orientation=squarish',
    inStock: true,
    categoryId: 'home-appliances',
  },
  {
    id: 'prod-8',
    name: 'رفوف سوبرماركت معدنية 5 طوابق',
    brand: 'بوش',
    price: 1299,
    rating: 4.8,
    reviews: 34,
    image: 'https://readdy.ai/api/search-image?query=metal%20supermarket%20shelving%20unit%205%20tiers%20commercial%20retail%20display%20rack%20product%20photography%20clean%20white%20background%20professional%20studio&width=600&height=600&seq=prod8&orientation=squarish',
    badge: 'عرض خاص',
    inStock: true,
    categoryId: 'supermarket-equipment',
  },
];

export const allProducts = [
  ...featuredProducts,
  ...bestSellers,
  {
    id: 'prod-9',
    name: 'مجفف ملابس إل جي 9 كيلو',
    brand: 'إل جي',
    price: 2299,
    rating: 4.5,
    reviews: 56,
    image: 'https://readdy.ai/api/search-image?query=lg%20clothes%20dryer%209kg%20white%20modern%20appliance%20product%20photography%20clean%20white%20background%20professional%20studio%20lighting&width=600&height=600&seq=prod9&orientation=squarish',
    inStock: true,
    categoryId: 'home-appliances',
  },
  {
    id: 'prod-10',
    name: 'كاونتر كاشير احترافي',
    brand: 'كريازي',
    price: 3499,
    rating: 4.7,
    reviews: 28,
    image: 'https://readdy.ai/api/search-image?query=professional%20checkout%20counter%20cashier%20desk%20retail%20store%20furniture%20modern%20design%20product%20photography%20clean%20white%20background&width=600&height=600&seq=prod10&orientation=squarish',
    inStock: true,
    categoryId: 'supermarket-equipment',
  },
  {
    id: 'prod-11',
    name: 'غرفة تبريد 3×4 متر',
    brand: 'بوش',
    price: 24999,
    rating: 4.9,
    reviews: 12,
    image: 'https://readdy.ai/api/search-image?query=commercial%20cold%20room%20refrigeration%20unit%203x4%20meters%20industrial%20cooling%20system%20product%20photography%20clean%20white%20background%20professional&width=600&height=600&seq=prod11&orientation=squarish',
    badge: 'للمشاريع',
    inStock: true,
    categoryId: 'project-solutions',
  },
  {
    id: 'prod-12',
    name: 'ثلاجة توشيبا 18 قدم',
    brand: 'توشيبا',
    price: 2899,
    oldPrice: 3399,
    discount: 15,
    rating: 4.6,
    reviews: 134,
    image: 'https://readdy.ai/api/search-image?query=toshiba%20refrigerator%2018%20cubic%20feet%20silver%20modern%20home%20appliance%20product%20photography%20clean%20white%20background%20studio%20lighting&width=600&height=600&seq=prod12&orientation=squarish',
    inStock: true,
    categoryId: 'home-appliances',
  },
];